import React from 'react';
import { Link } from 'react-router-dom';
import lang from './../Tools/Lang';


function TopBarSite(props) {


return (
  <>
       <div class="header_top_menu">
          <div class="container">
              <ul>
                <li>
                <a href="https://t.me/bitkala_ir" rel="nofollow">{lang.getStr('telegram_channel')}</a>
                </li> 
                <li>
                <Link to="/Contribution">{lang.getStr('Contribution')}</Link>
                </li>
                {/* <li>
                <Link to="/about-us">{lang.getStr('about_us')}</Link>
                </li>  */}
          
              </ul> 
              <ul>
            {/* <li>
              <Link to="/faqs">{lang.getStr('faqs')}</Link>
            </li>  */}
           
            <li>
              <Link to="/contact-us">{lang.getStr('contact_us')}</Link>
            </li>
          </ul>
          </div>
          </div>
  </>
) 
}

export default TopBarSite;